
/**
 * Attach Call Me event to links of class 'callMe'
 * (could be called from initOIDoc)
 */
function callMeButtonPopup() {
  $('#callMe').click(function (e) {
    const $dialog = $('#popup_content');
    const xView = e.pageX - $(window).scrollLeft();
    const yView = e.pageY - $(window).scrollTop();

    $dialog.html($loading);
    $dialog.load($(this).attr('href')).dialog({
      title: getMessage('call_me.title', 'Call Me'),
      minWidth: 380,
      appendTo: '#popup_content',
      position: [xView + 10, yView + 10],
    });

    return false;
  });
}
/**
 * convert the oi:gl tags to glossary links
 */
function convertToGlossaryLinks() 
{
	//find any oi:gl or oi:ml tag and turn it into a glossary url
	//<oi:gl key="glo_prescription_drugs">Coverage for Prescription Drugs</oi:gl>
  //<oi:ml key="ede.add_person.help"><i class="fas fa-question-circle"></i> Learn more about who to include.</oi:ml>
  //<oi:ml key="ede.add_person.help"><i class="fas fa-question-circle"></i> Learn more about who to include.</oi:ml>

	$("oi\\:gl").each(function() {
		let url = getContextPath()+"/eapp/glossarylookup?type=JSON&lookupTerm="+$(this).attr('key');
		 url+="&catalogId="+oiConfig.catalogId+"&clientId="+oiConfig.clientId; 
		const content = '<a class="iconGlossary" aria-label="Glossary Link" href="'+url+'">'+$(this).html()+"</a>";

    $(this).html(content);
  });

  convertOiMlToLinks();

    $("oi\\:ht").each(function() {
        const url = getContextPath()+"/eapp/messageresourcelookup?type=JSON&key="+$(this).attr('key');
		    const content = $('<a class="iconGlossary" aria-label="Learn More" href="'+url+'">'+$(this).html()+"</a>");

		    $(this).html(content);
    });
}

/**
 * load glossary links into popup model
 */
function initGlossaryLinks() {
  convertToGlossaryLinks();
  //attach glossary event listener to every link that has the icon glossary glass
  // Use event delegation so dynamically added .iconGlossary elements also get the handler
  $(document).off('click.glossaryLink', '.iconGlossary').on('click.glossaryLink', '.iconGlossary', function (e) {
    e.preventDefault();
    glossaryEventHandler($(this));

    return false;
  });
}

function glossaryEventHandler(aPopOver) {
  const triggerElement = aPopOver.get(0);
  let lHref = aPopOver.attr('href');

  if (lHref.indexOf('&clientId=') == -1) {
    lHref += '&clientId=' + oiConfig.clientId;
  }

  $.getJSON(lHref, function (data) {
    let title;
    let content;

    if (data.value) {
        const rId = aPopOver.attr('data-responder-id');
        content = typeof replaceSurveyPlaceHolderContent === 'function'
            ? replaceSurveyPlaceHolderContent(rId, data.value)
            : data.value;
        title = aPopOver.html().replace(/<\/?oitext[^>]*>/gi, '');
    } else {
        title = data.term;
        content = data.definition;
    }

    title = title || '\u00A0'; // Use non-breaking space if title is empty to prevent Bootstrap from hiding the popover

    aPopOver.attr('title', title);
    aPopOver.attr('data-bs-content', content);

    // Use MDB popover instead of jQuery/Bootstrap popover
    try {
      // Close any other open MDB popovers first
      document
        .querySelectorAll('[data-mdb-toggle="popover"]')
        .forEach(function (elem) {
          if (elem._mdbPopover) {
            elem._mdbPopover.hide();
          }
        });

      // Set MDB popover attributes
      triggerElement.setAttribute('data-mdb-toggle', 'popover');
      triggerElement.setAttribute('data-mdb-title', aPopOver.attr('title'));
      triggerElement.setAttribute(
        'data-mdb-content',
        aPopOver.attr('data-bs-content'),
      );
      triggerElement.setAttribute('data-mdb-trigger', 'manual');
      triggerElement.setAttribute('data-mdb-html', 'true');
      triggerElement.setAttribute('data-mdb-sanitize', 'false');

      // Create and show MDB popover
      if (typeof mdb !== 'undefined' && mdb.Popover) {
        const mdbPopover = new mdb.Popover(triggerElement, {
          trigger: 'manual',
          html: true,
          sanitize: false,
        });

        // Store reference for cleanup
        triggerElement._mdbPopover = mdbPopover;

        mdbPopover.show();

        // Wait for the popover to be inserted into DOM
        setTimeout(function () {
          const popoverEl = document.querySelector('.popover');

          if (!popoverEl) {
            return;
          }

          const cleanup = function () {
            $(document).off('.glossary');
            if (triggerElement._mdbPopover) {
              triggerElement._mdbPopover.hide();
            }
            if (triggerElement) triggerElement.focus();
          };

          popoverEl.setAttribute('role', 'dialog');
          popoverEl.setAttribute('aria-live', 'polite');
          popoverEl.setAttribute('tabindex', '-1');
          popoverEl.focus();

          $(document).on('keydown.glossary', function (e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
              cleanup();
              aPopOver.focus();
            }
          });

          $(document).on('mousedown.glossary', function (e) {
            if (
              !$(popoverEl).is(e.target) &&
              $(popoverEl).has(e.target).length === 0 &&
              !aPopOver.is(e.target)
            ) {
              cleanup();
            }
          });
        }, 100);
      } else {
        // Fallback to Bootstrap popover if MDB is not available
        console.warn('MDB not available, falling back to Bootstrap popover');
        if (typeof bootstrap !== 'undefined' && bootstrap.Popover) {
          // Set MDB popover attributes for consistency
          triggerElement.setAttribute('data-mdb-toggle', 'popover');
          triggerElement.setAttribute('data-mdb-title', aPopOver.attr('title'));
          triggerElement.setAttribute(
            'data-mdb-content',
            aPopOver.attr('data-bs-content'),
          );
          triggerElement.setAttribute('data-mdb-trigger', 'manual');
          triggerElement.setAttribute('data-mdb-html', 'true');

          // Close any other open Bootstrap popovers
          document
            .querySelectorAll('[data-mdb-toggle="popover"]')
            .forEach(function (elem) {
              if (elem !== triggerElement && elem._bsPopover) {
                elem._bsPopover.hide();
              }
            });

          const bsPopover = new bootstrap.Popover(triggerElement, {
            trigger: 'manual',
            html: true,
            sanitize: false,
          });

          // Store reference for cleanup
          triggerElement._bsPopover = bsPopover;
          bsPopover.show();

          // Wait for the popover to be inserted into DOM
          setTimeout(function () {
            const popoverEl = document.querySelector('.popover');

            if (!popoverEl) {
              return;
            }

            const cleanup = function () {
              $(document).off('.glossary');
              if (triggerElement._bsPopover) {
                triggerElement._bsPopover.hide();
              }
              if (triggerElement) triggerElement.focus();
            };

            popoverEl.setAttribute('role', 'dialog');
            popoverEl.setAttribute('aria-live', 'polite');
            popoverEl.setAttribute('tabindex', '-1');
            popoverEl.focus();

            $(document).on('keydown.glossary', function (e) {
              if (e.key === 'Escape' || e.keyCode === 27) {
                cleanup();
                aPopOver.focus();
              }
            });

            $(document).on('mousedown.glossary', function (e) {
              if (
                !$(popoverEl).is(e.target) &&
                $(popoverEl).has(e.target).length === 0 &&
                !aPopOver.is(e.target)
              ) {
                cleanup();
              }
            });
          }, 200);
        } else {
          console.warn('Neither MDB nor Bootstrap popover available');
        }
      }
    } catch (error) {
      console.error('Error creating MDB popover:', error);
      // Fallback to Bootstrap popover on error
      if (typeof bootstrap !== 'undefined' && bootstrap.Popover) {
        // Set MDB popover attributes for consistency
        triggerElement.setAttribute('data-mdb-toggle', 'popover');
        triggerElement.setAttribute('data-mdb-title', aPopOver.attr('title'));
        triggerElement.setAttribute(
          'data-mdb-content',
          aPopOver.attr('data-bs-content'),
        );
        triggerElement.setAttribute('data-mdb-trigger', 'manual');
        triggerElement.setAttribute('data-mdb-html', 'true');

        const bsPopover = new bootstrap.Popover(triggerElement, {
          trigger: 'manual',
          html: true,
          sanitize: false,
        });
        bsPopover.show();
      } else {
        console.warn('Neither MDB nor Bootstrap popover available');
      }
    }
  });
}





/**
 * called when the page renders
 */
function initOIDoc() {
  initGlossaryLinks();

  // Initialize MDB checkbox components for existing content
  // Set in shared-ui/mdb-helpers.js 
  initializeMDBComponentsForCheckboxes();
  initializeMDBComponentsForInputs();
  initializeSelects();
  initializeDatePickers();

  //Session inactivity timeout - shared-ui/js/timeout.js, bundled ahead of this file.
  //It owns the modal, countdown, "I'm Still Here" restart and excluded paths.
  initOITimeout({
    app: 'web',
    //server session-timeout is 15 minutes (web.xml): 12 minutes idle, then a 2:30 countdown
    //in the modal, so the logout POST lands while the session and its CSRF token still exist
    warningMs: 720000,
    countdownMs: 150000,
    extraExclusions: ['/eapp/content/demo_hub']
  });

  callMeButtonPopup();
}

//IOS click fix
function onClickReplace() {
  (function ($) {
    $.fn.tclick = function (onclick) {
      this.bind('touchstart', function (e) {
        onclick.call(this, e);
        e.stopPropagation();
        e.preventDefault();
      });
      this.bind('click', function (e) {
        onclick.call(this, e);
      }); //substitute mousedown event for exact same result as touchstart

      return this;
    };
  })(jQuery);
}

/**
 * switch the locale when available
 */
function switchLocaleListener() {
  $('a[class~="swithcLocale"]').click(function () {
    const url = $(this).attr('href');

    $.getJSON(url, function (data) {
      location.reload();
    });

    return false;
  });
}

const $loading =
  '<img src="' + getContextPath() + '/images/loader.gif" alt="loading" />';

// Using this over $(".datePickerBasic").daterangepicker so that it will work with dynamically added elements
$('body').on('focus',".datePickerBasic", function(){
	if ($(this).is('[readonly]')) {
		return;
	}
	$(this).daterangepicker({
		autoUpdateInput: false, //Don't pre-fill with a default before date selection
		autoApply: true,
		singleDatePicker: true,
		showDropdowns: true,
		minYear: 1901,
		maxYear: 2099,
		drops: 'auto'
	});
});
// Have to manually update on date selection when autoUpdateInput is off
$('body').on('apply.daterangepicker',".datePickerBasic", function(ev, picker){
	var $input = findInput($(this));
	$input.val(picker.startDate.format('MM/DD/YYYY'));
	$input.change(); // Fixes bootstrap material design floating label not floating
});
$('body').on('cancel.daterangepicker',".datePickerBasic", function(ev, picker){
	findInput($(this)).val('');
});

function findInput($that) {
  if ($that.prop('nodeName') == 'INPUT') {
    var $input = $that;
  } else {
    var $input = $that.closest('.input-group').find('.dateInput');
  }
  if (typeof $input === 'undefined' || $input.prop('nodeName') !== 'INPUT') {
    $input = $that.closest('.input-group').find('input.date');
  }
  return $input;
}

$(document).ready(function () {
  initOIDoc();
  switchLocaleListener();
  onClickReplace();
  applyCommonInputMasks();
  //why do we need this?
  $('a.back').click(function () {
    parent.history.back();

    return false;
  });
});
